import React from 'react';
import PropTypes from 'prop-types';

import {
  IconButton,
} from '@folio/stripes/components';

const ActionButton = ({
  icon,
  onClickHandler,
}) => {
  const additionalProps = {
    [`data-test-${icon}`]: true,
  };

  return (
    <IconButton
      {...additionalProps}
      icon={icon}
      onClick={onClickHandler}
    />
  );
};

ActionButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func.isRequired,
};

export default ActionButton;
